export var logger = console;


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-query/es/react/logger.js
// module id = 3433
// module chunks = 0